import React from 'react';

export const CustomProjectCategoryDetail = React.lazy(() => import('./pages/CustomProjectCategoryDetail'));
